var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TestCalltasksCampaign.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-534a2c9e\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TestCalltasksCampaign.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/calltasks/TestCalltasksCampaign.vue
// module id = 172
// module chunks = 42